export enum MovementSignType {
    incomes = '+',
    expenses = '-'
}

export enum Sign {
    plus = '+',
    minus = '-'
}